import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FormikCheckbox } from '~src/commonInfra/components/FormikCheckbox';
import { MetadataDrivenSiteSettings } from '~src/commonInfra/components/MetadataDrivenSiteSetting';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { SettingsSection } from '~src/settings/components/common/SettingsSection';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';


export const GROUP_SETS_SITE_ENABLED_FIELD = 'settings.groupSetsEnabled';
export const GROUP_SETS_SITE_SECTION_TEST_ID = 'group-sets-site-setting-section';
export const GROUP_SETS_SITE_ENABLED_CHECKBOX_TEST_ID = 'group-sets-site-enabled';
export const GROUP_SETS_SITE_LEARN_MORE_LINK_TEST_ID = 'group-set';
export const GROUP_SETS_SITE_SECTION_NAME = 'groupSetsEnabled';
export const GROUP_SETS_SITE_PREFIX = 'settings';

export type SiteGroupSetsSectionProps = SiteSettingsForSiteAdminProps<'groupSetsEnabled'>;

export function SiteGroupSetsSection(props: SiteGroupSetsSectionProps): React.ReactElement {
    if (FeatureFlags.metadataDrivenSiteSettingsEnabled) {
        return (
            <SettingsSection
                title={Messages.groupSetsSettingTitle()}
                testId={GROUP_SETS_SITE_SECTION_TEST_ID}>
                    <MetadataDrivenSiteSettings
                        sectionName={GROUP_SETS_SITE_SECTION_NAME}
                        formikPrefix={GROUP_SETS_SITE_PREFIX}/>
            </SettingsSection>
        );
    }

    return (
        <SettingsSection
            description={renderDescription()}
            title={Messages.groupSetsSettingTitle()}
            testId={GROUP_SETS_SITE_SECTION_TEST_ID}>
                <FormikCheckbox
                    label={Messages.groupSetsSettingLabel()}
                    name={GROUP_SETS_SITE_ENABLED_FIELD}
                    testId={GROUP_SETS_SITE_ENABLED_CHECKBOX_TEST_ID}/>
        </SettingsSection>
    );
}

function renderDescription() {
    return (
      <div>
        {Messages.groupSetsSettingDescription()}
        <TextLinkWidget testId={GROUP_SETS_SITE_LEARN_MORE_LINK_TEST_ID}
                        target={'_blank'}
                        className={learnMoreStyle}
                        href={HelpService.getHelpUrlByCategory('group-set')}>
          {Messages.learnMore()}
        </TextLinkWidget>
      </div>
    );
  }

/* for registering the component in settings registry */
export const SiteGroupSetsSectionSpecs = componentRegistryEntry({
    name: 'SiteGroupSetsSection',
    component: SiteGroupSetsSection
});
